"use strict";
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.STATUS_PROPTYPE = exports.ERROR = exports.UNINSTALLED = exports.INSTALLED = exports.PENDING = exports.NOT_INITIALIZED = void 0;

var _react = require("react");

var NOT_INITIALIZED = 'NOT_INITIALIZED';
exports.NOT_INITIALIZED = NOT_INITIALIZED;
var PENDING = 'PENDING';
exports.PENDING = PENDING;
var INSTALLED = 'INSTALLED';
exports.INSTALLED = INSTALLED;
var UNINSTALLED = 'UNINSTALLED';
exports.UNINSTALLED = UNINSTALLED;
var ERROR = 'ERROR';
exports.ERROR = ERROR;

var STATUS_PROPTYPE = _react.PropTypes.oneOf([NOT_INITIALIZED, PENDING, INSTALLED, UNINSTALLED, ERROR]).isRequired;

exports.STATUS_PROPTYPE = STATUS_PROPTYPE;